import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { CollabRequests } from "../../admin/adminHomePage/CollabRequests";
import { usePage } from "@inertiajs/react";

const InviteRequestsPage = () => {
  const { auth } = usePage().props;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Typography variant="h5" fontWeight={700} color="primary.main" mb={1.5}>Invite Requests</Typography>
      <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', padding: 2 }}>
        <CollabRequests
          title={'Collab Invitations Sent'}
          subTitle={'Track the status of the collab invitations you’ve sent. Check if your invites have been accepted, pending, or declined.'}
          isCollabRequest={false}
          viewOnly={true}
          showHeader={false}
          additionalProps={{ per_page: 10, user_id: auth?.user?.id, direction: 'inbound' }}
        />
      </Card>
    </Box>
  );
}

export default InviteRequestsPage;